
import { Component, Vue } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { InvoicePreviewDto } from "@/dtos/invoicePreviewDto";

@Component
export default class PaperInvoicesView extends Vue {
	private isLoading = false;
	private downloadingId: number | null = null;
	private printingId: number | null = null;
	private sentId: number | null = null;
	private invoices: InvoicePreviewDto[] = [];

	private headers = [
		{ text: "Rechnungs-Id", value: "invoiceId", align: "left", sortable: false },
		{ text: "Auftrags-Id", value: "orderId", align: "left", sortable: false },
		{ text: "Kunde", value: "customerName", align: "left", sortable: false },
		{ text: "Lieferdatum", value: "deliveryDate", align: "left", sortable: false },
		{ text: "", value: "actions", align: "right", sortable: false },
	];

	private get isBusy() {
		return this.downloadingId !== null || this.printingId !== null || this.sentId !== null;
	}

	private async mounted() {
		await this.loadInvoices();
	}

	private async loadInvoices() {
		this.isLoading = true;
		try {
			const response = await httpClient().get("CustomerOrder/GetInvoicesToPrint");
			this.invoices = response.data;
		} catch (e) {
			console.log("Loading paper invoices failed.", e);
		} finally {
			this.isLoading = false;
		}
	}

	private async getPdfBlob(invoiceId: number): Promise<Blob> {
		const response = await httpClient().get(
			`CustomerOrder/GetInvoiceAsObject?invoiceId=${invoiceId}&invoicePart=All`
		);
		const base64 = response.data.data as string;
		const binary = atob(base64);
		const bytes = new Uint8Array(binary.length);
		for (let i = 0; i < binary.length; i++) {
			bytes[i] = binary.charCodeAt(i);
		}
		return new Blob([bytes], { type: "application/pdf" });
	}

	private async downloadPdf(invoiceId: number) {
		this.downloadingId = invoiceId;
		try {
			const blob = await this.getPdfBlob(invoiceId);
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `Rechnung ${invoiceId}.pdf`);
			link.click();
			window.URL.revokeObjectURL(url);
		} catch (e) {
			console.log("Download invoice pdf failed.", e);
		} finally {
			this.downloadingId = null;
		}
	}

	private async printPdf(invoiceId: number) {
		this.printingId = invoiceId;
		try {
			const blob = await this.getPdfBlob(invoiceId);
			const url = window.URL.createObjectURL(blob);
			const printWindow = window.open(url);
			if (printWindow) {
				printWindow.onload = () => {
					printWindow.print();
					window.URL.revokeObjectURL(url);
				};
			}
		} catch (e) {
			console.log("Print invoice pdf failed.", e);
		} finally {
			this.printingId = null;
		}
	}

	private async setAsSent(invoiceId: number) {
		this.sentId = invoiceId;
		try {
			await httpClient().post(`CustomerOrder/SetInvoiceAsSent?invoiceId=${invoiceId}`);
			this.invoices = this.invoices.filter((i) => i.invoiceId !== invoiceId);
		} catch (e) {
			console.log("Setting invoice as sent failed.", e);
		} finally {
			this.sentId = null;
		}
	}

	private navigateToInvoiceEdit(invoiceId: number) {
		this.$router.push({ name: "editInvoice", params: { invoiceId: invoiceId.toString() } });
	}
}
